module.exports = __webpack_public_path__ + "topText-white-bg.png?94d1ee39c6a5324a5a8b74806b317282";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/topText-white-bg.png
// module id = 7
// module chunks = 0